import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Toast, ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as sjcl from 'sjcl';
import { User } from '../models/login-users';
import { AuthService } from '../service/auth.service';
import { CookiesService } from '../service/cookies.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent /* implements OnInit */ {
  constructor(
    private router: Router,
    private auth: AuthService,
    vRef: ViewContainerRef,
    private toastr: ToastsManager,
    private cookies: CookiesService
  ) {
    this.toastr.setRootViewContainerRef(vRef);
    this.user = new User('', '', false);
    this.router = router;
  }

  user;

  errorMsg = false;

  successMsg = false;

  msg = '';

  onsubmit() {
    // console.log('dfcasdf');
    // if(this.user.email=='' || this.user.email=='undefined'){
    //     this.toastr.error('please enter email');
    // }

    // if(this.user.password=='' || this.user.password=='undefined'){
    //     this.toastr.error('please enter password');
    // }

    //
    // Protect the user's password. Hash it here in the client so the backend knows nothing of the actual
    // password.
    //
    // Create a SHA-236 hash object.
    //
    const sha256 = new sjcl.hash.sha256();
    const hashedPasswordBitArray = sha256.update(this.user.password).finalize();

    //
    // Generate a salt that we will append to the hashed password in order to prevent rainbow table attacks and rehash the combination.
    //
    const saltArray = sjcl.random.randomWords(2, 0); // 2 words (16 bits)
    const saltedHashedPwd = sjcl.bitArray.concat(hashedPasswordBitArray, saltArray);
    sha256.reset();
    const hashedResult = sha256.update(saltedHashedPwd).finalize();

    //
    // Now encrypt a payload that includes the username, hashed password, and the salt.
    //
    const payload = {
      username: this.user.username,
      password: hashedResult,
      salt: saltArray,
    };
    // console.log('payload',payload);
    const payloadString = JSON.stringify(payload); // sjcl.json.encode(payload);
    const encryptedPayload = sjcl.encrypt('ralFinancialSuite', payloadString);

    //
    // Ask the back end for the development/admin user's information that we can package into a JWT before
    // redirecting to the root (which will then do the auth as if they were sent over by the RAL Academy site).
    //
    this.auth.devLogin(encryptedPayload).subscribe((res) => {
      // console.log(`In LoginComponent:: success. Token = ${res.token}`);
      //
      // Get the token out of the API response.
      //
      const { token } = res;

      //
      // Set the token in a cookie.
      //
      // console.log('Setting jwt cookie');
      this.cookies.set('jwt', token, 5);

      this.auth.isAdmin().subscribe((result) => {
        // console.log(`User is ${result !== true ? 'NOT ' : ''}an administrator`);
        // console.log('Navigating to /');
        this.router.navigate(['/']);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts